import { AppRouter } from './router';

/**
 * 메인 애플리케이션 컴포넌트
 * - 애플리케이션 진입점
 * - 라우터 설정
 * - 글로벌 설정
 */
function App() {
  return (
    <div className="App">
      <AppRouter />
    </div>
  );
}

export default App;
